import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/job-positions/agreement/loading';
import { getJobPositionQueryOptions } from '@/_pages/settings/job-positions/api-service';

export const Route = createFileRoute('/_private/settings/job-positions/_template/$id/advertisement')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getJobPositionQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Job Listing & Advertisement',
    tabKey: 'settings/job-position/advertisement',
  },
  pendingComponent: Loading,
});
